import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import LogoLoader from "./components/LogoLoader";
import Navbar from "./components/Navbar";
import Hero2 from "./components/Hero2";
import WideRangeSelection from "./components/WideRangeSelection";
import Products from "./components/Products";
import PaintCalculator from "./components/PaintCalculator";
import AboutUs from "./components/AboutUs";
import ExpertTeam from "./components/ExpertTeam";
import PaintFinishes from "./components/PaintFinishes";
import Brands from "./components/Brands";
import Footer from "./components/Footer";
import EstorePage from "./pages/EstorePage";
import PaintCPage from "./pages/PaintCPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProductDetails from "./components/ProductDetails";
import Aboutuspage from "./pages/Aboutuspage";
import CartPage from "./pages/CartPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelPage from "./pages/CheckoutCancelPage";
import CreatorPage from "./pages/CreatorPage";

function App() {
     const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    let minDelayTimer;
    const hideLoader = () => {
      minDelayTimer = setTimeout(() => setShowLoader(false), 900);
    };

    if (document.readyState === "complete") {
      hideLoader();
    } else {
      window.addEventListener("load", hideLoader);
    }

    const fallbackTimer = setTimeout(() => setShowLoader(false), 2200);

    return () => {
      window.removeEventListener("load", hideLoader);
      clearTimeout(minDelayTimer);
      clearTimeout(fallbackTimer);
    };
  }, []);

  if (showLoader) {
    return <LogoLoader />;
  }

  const isAdminLoggedIn = !!localStorage.getItem("admin_token");
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={
          <div className="home-page">
            <Navbar />
            <Hero2 />
            <WideRangeSelection />
            <Products />
            <PaintCalculator />
            <AboutUs />
            <ExpertTeam />
            <PaintFinishes />
            <Brands />
            <Footer />
          </div>
        } />
        <Route path="/e-store" element={<EstorePage />} />
        <Route path="/paint-calculator" element={<PaintCPage />} />
        <Route path="/about-us" element={<Aboutuspage />} />
        <Route path="/admin" element={isAdminLoggedIn ? <Navigate to="/admin/dashboard" /> : <AdminLogin />} />
        <Route path="/admin/dashboard" element={isAdminLoggedIn ? <AdminDashboard /> : <Navigate to="/admin" />} />
        <Route path="/estore" element={<EstorePage />} />
        <Route path="/product/:slug" element={<ProductDetails />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
        <Route path="/creator" element={<CreatorPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ScrollToTopButton />
    </Router>
  );
}

export default App;
